"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createItemDisplay = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const Item_1 = require("../../../classes/Item");
const createImage_1 = require("./createImage");
const createPanel_1 = require("./createPanel");
const createPressableButton_1 = require("./createPressableButton");
const createSlot_1 = require("./createSlot");
const doesItemHaveVanity_1 = require("../../doesItemHaveVanity");
const definables_1 = require("definables");
const getEquipmentPieceClassesText_1 = require("../../getEquipmentPieceClassesText");
const getEquipmentSlotName_1 = require("../../getEquipmentSlotName");
const getItemVanityClassesText_1 = require("../../getItemVanityClassesText");
const getItemVanitySlotText_1 = require("../../getItemVanitySlotText");
const createItemDisplay = ({ buttons, condition, itemID, onClose, }) => {
    const hudElementReferences = [];
    const labelIDs = [];
    const getItem = () => (0, definables_1.getDefinable)(Item_1.Item, typeof itemID === "function" ? itemID() : itemID);
    // Selected bag item panel
    hudElementReferences.push((0, createPanel_1.createPanel)({
        condition,
        height: 76,
        imagePath: "panels/basic",
        width: 176,
        x: 0,
        y: 132,
    }));
    // Selected bag item icon
    hudElementReferences.push((0, createSlot_1.createSlot)({
        condition,
        icons: [
            {
                imagePath: () => getItem().iconImagePath,
            },
        ],
        imagePath: "slots/basic",
        x: 7,
        y: 139,
    }));
    // Selected bag item name
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition,
            x: 27,
            y: 144,
        },
        horizontalAlignment: "left",
        text: () => ({
            value: getItem().name,
        }),
    }));
    // Selected bag item close button
    hudElementReferences.push((0, createImage_1.createImage)({
        condition,
        height: 11,
        imagePath: "x",
        onClick: onClose,
        width: 10,
        x: 159,
        y: 139,
    }));
    // Selected bag item description
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasDescription();
                }
                return false;
            },
            x: 8,
            y: 159,
        },
        horizontalAlignment: "left",
        maxLines: 3,
        maxWidth: 160,
        text: () => ({
            value: getItem().description,
        }),
    }));
    // Selected bag item strength
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 40,
            y: 161,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.strength} STR`,
        }),
    }));
    // Selected bag item intelligence
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 88,
            y: 161,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.intelligence} INT`,
        }),
    }));
    // Selected bag item agility
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 136,
            y: 161,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.agility} AGI`,
        }),
    }));
    // Selected bag item defense
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 40,
            y: 172,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.defense} DEF`,
        }),
    }));
    // Selected bag item wisdom
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 88,
            y: 172,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.wisdom} WIS`,
        }),
    }));
    // Selected bag item luck
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 136,
            y: 172,
        },
        horizontalAlignment: "center",
        text: () => ({
            value: `${getItem().equipmentPiece.luck} LCK`,
        }),
    }));
    // Selected bag item vanity slot
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return (0, doesItemHaveVanity_1.doesItemHaveVanity)(getItem().id);
                }
                return false;
            },
            x: 7,
            y: 183,
        },
        horizontalAlignment: "left",
        text: () => ({
            value: (0, getItemVanitySlotText_1.getItemVanitySlotText)(getItem().id),
        }),
    }));
    // Selected bag item equipment slot
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return getItem().hasEquipmentPiece();
                }
                return false;
            },
            x: 7,
            y: 183,
        },
        horizontalAlignment: "left",
        text: () => ({
            value: (0, getEquipmentSlotName_1.getEquipmentSlotName)(getItem().equipmentPiece.slot),
        }),
    }));
    // Selected bag item vanity requirements
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    return (0, doesItemHaveVanity_1.doesItemHaveVanity)(getItem().id);
                }
                return false;
            },
            x: 7,
            y: 194,
        },
        horizontalAlignment: "left",
        text: () => ({
            value: (0, getItemVanityClassesText_1.getItemVanityClassesText)(getItem().id),
        }),
    }));
    // Selected bag item equipment requirements
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition: () => {
                if (typeof condition === "undefined" || condition()) {
                    const item = (0, definables_1.getDefinable)(Item_1.Item, getItem().id);
                    return item.hasEquipmentPiece();
                }
                return false;
            },
            x: 7,
            y: 194,
        },
        horizontalAlignment: "left",
        text: () => ({
            value: (0, getEquipmentPieceClassesText_1.getEquipmentPieceClassesText)(getItem().equipmentPieceID),
        }),
    }));
    // Buttons
    if (typeof buttons !== "undefined") {
        for (const button of buttons) {
            hudElementReferences.push((0, createPressableButton_1.createPressableButton)({
                condition: () => {
                    if (typeof condition === "undefined" || condition()) {
                        return button.condition();
                    }
                    return false;
                },
                height: 16,
                imagePath: "pressable-buttons/gray",
                onClick: button.onClick,
                text: { value: button.text },
                width: button.width,
                x: button.x,
                y: 185,
            }));
        }
    }
    return (0, pixel_pigeon_1.mergeHUDElementReferences)([
        {
            labelIDs,
        },
        ...hudElementReferences,
    ]);
};
exports.createItemDisplay = createItemDisplay;
